import React, { useEffect, useState, useRef } from 'react';
import TableView from '../../table/TableView';
import { AnimatePresence, motion } from "framer-motion";
import { useQuery, useLazyQuery, useSubscription } from '@apollo/client';
import { ALL_USERS_QUERY, USER_ALL_DETAILS_QUERY } from '../../../graph/AdminGraph';
// import { RECENT_REPORTS_SUBSCRIPTION } from '../../graph/ReportGraph';

function AdminListAllUsers() {

    const [cursor, setCursor] = useState("")

    const [getLazyAllUsers, lazyAllUsers] = useLazyQuery(ALL_USERS_QUERY, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    useEffect(() => {
        getLazyAllUsers()
    }, [])

    const [getLazyUserAllDetails, lazyUserAllDetails] = useLazyQuery(USER_ALL_DETAILS_QUERY, {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    });

    const nodes = lazyAllUsers.data?.usersConnectionFiltered.edges.map((edge) => edge.node);
    const pageInfo = lazyAllUsers.data?.usersConnectionFiltered.pageInfo;
    const networkStatus = lazyAllUsers.networkStatus
    const fetchMore = lazyAllUsers.fetchMore
    const loading = lazyAllUsers.loading || lazyUserAllDetails.loading

    return (
        <>
            <TableView
                key={"explore-search-table-view"}
                // set table properties
                // tableSize={"small"}
                expandable={true}
                // only if expandable, need below parameters are mandatory for details
                rowClick={getLazyUserAllDetails}
                rowDetails={lazyUserAllDetails.data?.user}
                rowDetailsVariable={"id"}
                rowDetailsKeysToExclude={["id", "__typename", "favourites", "recentViews", "notifications"]}

                data={nodes}
                pageInfo={pageInfo}
                networkStatus={networkStatus}
                fetchMore={fetchMore}
                loading={loading}
                keysToRemove={[
                    // 'id',
                    // 'slug',
                    'orgDetails',
                    '__typename',
                ]}
                relayPagination={true}
                // below inputs are required only if relay based  pagination is enabled 
                cursor={cursor}
                setCursor={setCursor}
                // keysToKeep={[]}
                orderBy={'dateJoined'}
                order={"desc"}
                // nestedField={"report"}
                // otherFields={['visitTime']}
                // TODO: #27 Add sticky header to table component
                stickyHeader={true}
            />
        </>
    )
}

export default AdminListAllUsers;
